module.exports = __webpack_public_path__ + "static/user-research-url-2-f35f040cdab259405ce2fc953e220204.png";